import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Which of the caller's customers the portal is currently showing.
//
// Null means "all of them", which is the correct default for the handful of
// accounts linked to several kundekort. It is only ever a FILTER: the server
// re-derives the full permitted scope from the account on every request, so
// nothing here can widen what is visible.
@Injectable({ providedIn: 'root' })
export class PortalStateService {

  customerId$ = new BehaviorSubject<string | null>(null);

  get customerId(): string | null { return this.customerId$.value; }

  selectCustomer(customerId: string | null) {
    this.customerId$.next(customerId || null);
  }
}
